export async function checkCameraPermissions() {
  return true
}
